import { Paper, PaperProps } from '@mui/material';
import { FC, ReactNode } from 'react';

type VyPaperProps = PaperProps & {
  children: ReactNode;
};

export const VyPaper: FC<VyPaperProps> = ({ children, sx, ...props }) => {
  return (
    <Paper sx={{ padding: '20px', borderRadius: '10px', ...sx }} {...props}>
      {children}
    </Paper>
  );
};
